var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 9,
  height: 9,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.644 4.808 5.825 3.64 4.807.725 3.641 3.641l-2.916.92L3.64 5.827l.92 2.818 1.264-2.818 2.819-1.018Z",
  fill: "#9990EA"
})));
export { SvgStar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgOSA5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguNjQ0MDMgNC44MDc2N0w1LjgyNTE4IDMuNjQxMjlMNC44MDcyNCAwLjcyNTE4NUwzLjY0MDc0IDMuNjQxMjlMMC43MjQ3OTcgNC41NjE4NkwzLjY0MDc0IDUuODI1NzNMNC41NjE1OSA4LjY0NDM0TDUuODI1MTggNS44MjU3M0w4LjY0NDAzIDQuODA3NjdaIiBmaWxsPSIjOTk5MEVBIi8+Cjwvc3ZnPgo=";